import React from "react";
import {connect} from "react-redux";
import {IStore} from "../../../store/reducers";
import actionTypes from "../../../store/actionTypes";
import BienvenidoIcon from "../../../icons/PNGs/bienvenido.png";
import {Typography} from "@material-ui/core";


interface IProps {
}

interface Istate {
}


class BienVenido extends React.Component<IProps, Istate> {

    state:Istate = {
    }


    render() {

        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    height: '100%',
                    backgroundColor: "#2BEBC8",
                    borderRadius: 20
                }}
            >
                <link rel="stylesheet"
                      href="https://fonts.googleapis.com/css?family=Poppins"
                />
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        width: '100%',
                        height: '50%'
                    }}
                >
                    <img
                        style={{maxHeight: "90%", maxWidth: "90%"}}
                        src= {BienvenidoIcon}
                        alt=''
                    />
                </div>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-start",
                        justifyContent: "center",
                        width: '100%',
                        height: '50%'
                    }}
                >
                    <Typography
                        style={{
                            width: '100%',
                            marginTop: 10,
                            marginLeft: 40,
                            fontFamily: "Poppins",
                            fontWeight: "bold"
                        }}
                    >
                        ¡Bienvenido!
                    </Typography>
                </div>

            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(BienVenido);
